module.exports = __webpack_public_path__ + "img/ozimkiewiczinsta.d1f50c08.jpg";